module.exports = __webpack_public_path__ + "img/robot_profile_pic.c0e1c169.jpg";